import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Spacer, PageDS, ToastContainerDS, TabMenu } from "@qivia/ui";
import { useNavigate, useParams } from "react-router-dom";
import { UpdatePhoneDriverTab } from "./updatePhoneDriverTab";
import { RelaunchSmsTab } from "./relaunchSmsTab";
import "../../i18n/i18n";
import { AssociateRelatedDriversTab } from "./associateRelatedDriversTab";

export const CompaniesDrivers = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [selectedTab, setSelectedTab] = useState<string>(
    params.tab ?? "relatedDriverRequests",
  );

  useEffect(() => {
    if (selectedTab) {
      navigate(`/home/drivers/${selectedTab}`);
    }
  }, [navigate, selectedTab]);

  const tabs = [
    {
      name: "relatedDriverRequests",
      title: t("drivers.tab.relatedDriverRequests"),
    },
    {
      name: "resendSms",
      title: t("drivers.tab.resendSms"),
    },
    {
      name: "updatePhone",
      title: t("drivers.tab.updatePhone"),
    },
  ];

  return (
    <PageDS
      title={t(`drivers.${params.tab}`)}
      toaster={<ToastContainerDS />}
      topElement={
        <>
          <Spacer y={1} />
          <TabMenu
            tabs={tabs}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
        </>
      }
    >
      <UpdatePhoneDriverTab />
      <RelaunchSmsTab />
      <AssociateRelatedDriversTab />
    </PageDS>
  );
};
